/*
Copyright 2025 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import i18next, { initPromise } from '@/i18n/i18next'
import { type TFunction } from 'i18next';

i18next.isInitialized

export async function translate(key:string, options?:any) : Promise<string> {
  await initPromise;
  return i18next.t(key, options) as string;
}